// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"27":"7ab54942","163":"7ab54942","512":"13b3671f"}[chunkId] + ".css";
};